
import { useEffect } from 'react';
import { useRef } from 'react';
import { useBalance } from '../Hooks/useBalance';
import { useEarn } from '../Hooks/useEarn';
import { useFlame } from '../Hooks/useFlame';
import { useTvl } from '../Hooks/useTvl';
import styles from '../styles/EarnCard.module.css'
import Web3Modal from 'web3modal'
import { ethers } from 'ethers';
import { Abi } from '../constants/Abi';



const Address = '0x4623e73aF94Ea2F29b89136392b38D352FC1410D';

export const EarnCard = () => {
    const web3ModalRef = useRef()
    
    const [ tvl, setTvl  ] = useTvl( );
    const [ earn, setEarn ] = useEarn();
    const [ balance, setBalance ] = useBalance();
    const [ referrals,setReferrals ] = useFlame();

    //handleTvl
    const handleTvl = async () => {
        const provider = await web3ModalRef.current.connect();
        const web3Provider = new ethers.providers.Web3Provider(provider);
        const signer = await web3Provider.getSigner();
        const Vault = new ethers.Contract(
            Address,
            Abi,
            signer
        );
        try {
            const tvltx = await Vault.getBalance();
            const tx = ethers.utils.formatUnits(tvltx, 18)
            setTvl(parseFloat(tx).toFixed(2));
        } catch (error) {
            console.log(error)
        }
    };

    const handleEarning = async () => {
        const provider = await web3ModalRef.current.connect();
        const web3Provider = new ethers.providers.Web3Provider(provider);
        const signer = await web3Provider.getSigner();
        const Vault = new ethers.Contract(
            Address,
            Abi,
            signer
        )
        try {
           const earnTx = await Vault.getMyEggs();
           const tx = ethers.utils.formatUnits(earnTx, 18);
           setEarn(parseFloat(tx).toFixed(8));
        } catch (error) {
            console.log(error)
        }
    };


    const handleBalance = async () => {
        const provider = await web3ModalRef.current.connect();
        const web3Provider = new ethers.providers.Web3Provider(provider);
        const accounts = await web3Provider.listAccounts();
        const add = accounts[0];
        try {
            const bls = await web3Provider.getBalance(add);
            const bala = (ethers.utils.formatEther(bls));
            setBalance(parseFloat(bala).toFixed(2));
        } catch (error) {
            console.log(error)
        }
    };
    useEffect(() => {
        web3ModalRef.current = new Web3Modal({
            network: 'rinkeby',
            providersOption: {},
        })

    });
    useEffect(() => {
       handleTvl();
       handleBalance();
       handleEarning();
    },[])
    
    return(
    <div className={styles.container}>
        <div className={styles.card}>
            <div className={styles.typo}>
                <h3>{`Total Value Locked : ${tvl} MATIC`}</h3>
                <h3>{`Wallet Balance: ${balance} MATIC`}</h3>
                <h3>{`Your Earnings: ${earn} MATIC`}</h3>
                <h2 >{`Your Referrals: ${referrals}`}</h2>
            </div>
        </div>
    </div>
    );
}